<template>
    <div class="opModal">
        <div class="boxTitle">
            Configurazione campo aggiuntivo
        </div>
        <div class="body">
            <div class="form-group">
                <label>Etichetta</label>
                <localized-value v-slot:default="slotData">
                    <input type="text" class="form-control" v-model="config.label.values[slotData.selectedLanguage]" />
                </localized-value>
            </div>
            <div class="form-group d-flex mt-3">
                <input type="checkbox" class="form-control" v-model="config.required" />
                <label>Campo obbligatorio</label>
            </div>
            <div class="form-group d-flex mt-3">
                <input type="checkbox" class="form-control" v-model="config.isSelect" :disabled="config.isMultiSelect" />
                <label>Campo a risposta singola predefinita</label>
            </div>
            <div class="form-group d-flex mt-3">
                <input type="checkbox" class="form-control" v-model="config.isMultiSelect" :disabled="config.isSelect" />
                <label>Campo a risposta multipla predefinita</label>
            </div>
            <div class="form-group mt-3" v-if="config.isMultiSelect || config.isSelect">
                <label>Risposte possibili <button class="ms-2 btn btn-sm btn-success" @click="addRisposta">+</button></label>
                <div class="form-group mt-1 d-flex align-items-center" v-for="(item, i) in config.options" :key="i">
                    <localized-value v-slot:default="slotData">
                        <input class="form-control" type="text" :placeholder="'Risposta ' + (i + 1)" v-model="config.options[i].values[slotData.selectedLanguage]" />
                    </localized-value>
                    <button class="btn btn-sm btn-danger ms-2" @click="removeRiposta(i)">-</button>
                </div>
            </div>

            <div class="text-center mt-3">
                <button class="btn btn-success" @click="$emit('close')">Chiudi</button>
            </div>
        </div>
    </div>
</template>

<script lang="ts">
import * as OM from '@/model';
import * as Const from '@/const';
import * as VM from '@/viewmodel';
import { mixins, Options, Vue } from 'vue-class-component';
import WithModel from '@/mixins/withModel';
import { Prop } from 'vue-property-decorator';

@Options({})
export default class formItemConfigModal extends mixins(WithModel) {

    @Prop() config: OM.FormItemConfig;

    addRisposta(){
        this.config.options.push(new OM.LocalizedValue());
    }
    removeRiposta(i: number){
        this.config.options.splice(i, 1);
    }

}
</script>

<style scoped>

</style>
